import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SvgIconService } from './svg-icon.service';

/**
 * Displays an SVG icon
 */
@Component({
  selector: 'svg-icon',
  template: '<ng-template>{{ _src }}</ng-template>'
})
export class SvgIconComponent implements OnInit {
  /**
   * The sanitized HTML code
   */
  svg: SafeHtml = '';

  /**
   * The source
   */
  public _src = '';

  /**
   * Sets the source
   */
  @Input() set src(value: string) {
    if (value) {
      this._src = value;
      this.setSrc(this._src);
    }
  }

  /**
   * Constructor
   * @param http HttpClient
   * @param el ElementRef
   */
  constructor(private el: ElementRef, private service: SvgIconService) { }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.setSrc(this._src);
  }

  /**
   * Sets the source
   * @param source source
   */
  private setSrc(source: string) {
    if (source) {
      this.service.loadSvg(source).then((svg) => {
        this.el.nativeElement.innerHTML = svg;
      });
    }
  }
}
